import React from "react";
import {dateToPersian} from "../../../system/utils";

function normalizeTaskDate(value) {
    if (!value) return null;
    if (typeof value === "number") return new Date(value < 1000000000000 ? value * 1000 : value);
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function TaskDateTime({value, className = "text-xs"}) {
    const date = normalizeTaskDate(value);
    if (!date) return null;
    return (
        <span className={`${className} font-normal flex align-items-center gap-1 white-space-nowrap`} dir="rtl">
            <span>{dateToPersian(date, "HH:mm")}</span>
            <span>-</span>
            <span>{dateToPersian(date, "YYYY/MM/DD")}</span>
        </span>
    );
}

function TaskTimeRange({task, className = "text-2xs text-400"}) {
    const start = normalizeTaskDate(task?.startAt);
    const end = normalizeTaskDate(task?.dueDate);
    if (!start && !end) return null;

    const sameDay = start && end && start.toDateString() === end.toDateString();
    const format = sameDay ? "HH:mm" : "YYYY/MM/DD HH:mm";

    return (
        <span className={`${className} flex align-items-center gap-1 white-space-nowrap`} dir="ltr">
            {start && <span>{dateToPersian(start, format)}</span>}
            {start && end && <span>-</span>}
            {end && <span>{dateToPersian(end, format)}</span>}
        </span>
    );
}

export default TaskTimeRange;
